// Get CustomEvents to work with TypeScript
// https://stackoverflow.com/questions/47166369/argument-of-type-e-customevent-void-is-not-assignable-to-parameter-of-ty

const isCustomEvent = (event: Event): boolean => 'detail' in event;

export default isCustomEvent;
